import { SearchResultImage } from 'common/types/search-interfaces'
import React from 'react'
import {
  SearchItemInterface,
  SearchItemTextInterface,
} from 'src/shared/types/entities/search-interface'
import {
  SearchItemContainerUi,
  SearchItemImageContainerUi,
  SearchItemTextUi,
  SearchItemTitleUi,
  SearchItemUi,
} from './ui'

interface SearchItemProps {
  title: string
  text: string
  image: SearchResultImage | null
  path: string
  itemProps: SearchItemInterface
  itemTitleProps: SearchItemTextInterface
  itemTextProps: SearchItemTextInterface
  isPreviewMode: boolean
}

export const SearchItem = (props: SearchItemProps) => {
  const handleClick = () => {
    if (!props.isPreviewMode) {
      window.location.href = `${window.location.origin}${props.path}`
    }
  }
  return (
    <SearchItemUi {...props.itemProps} onClick={handleClick}>
      <SearchItemImageContainerUi imagePath={props.image?.path || ''} />
      <SearchItemContainerUi>
        <SearchItemTitleUi
          {...props.itemTitleProps}
          key={props.path}
          // biome-ignore lint/security/noDangerouslySetInnerHtml: <explanation>
          dangerouslySetInnerHTML={{ __html: props.title }}
        />
        <SearchItemTextUi
          {...props.itemTextProps}
          // biome-ignore lint/security/noDangerouslySetInnerHtml: <explanation>
          dangerouslySetInnerHTML={{ __html: props.text }}
        />
      </SearchItemContainerUi>
    </SearchItemUi>
  )
}
